import React from 'react';

const Uganda1_university_sta = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_university_sta;
